import { QueryResponse } from "../hooks/useMoneyHashQuery";
import { axiosApiInstance } from "../pages/api/axios";
import { parseErrorsToArray } from "./parseErrors";

export const getOrganizationsWithSearch = async (searchKeyword?: string) => {
  const params: any = {
    offset: 0,
    limit: 10,
  };
  if (searchKeyword) {
    params.q = searchKeyword;
  }
  return axiosApiInstance
    .get<QueryResponse<Array<[string, string]>>>(`/d/organizations/search/`, {
      params,
    })
    .catch((error) => {
      return Promise.reject(parseErrorsToArray(error)?.[0]);
    });
};

export const getAccountsWithSearch = async (
  searchKeyword?: string,
  organizationId?: string
) => {
  const params: any = {
    offset: 0,
    limit: 10,
  };
  if (searchKeyword) {
    params.search = searchKeyword;
  }
  if (organizationId) {
    params.organization = organizationId;
  }
  return axiosApiInstance
    .get<
      QueryResponse<
        Array<{
          columns: {
            id: string;
            name: string;
            created: string;
          };
          preview: {
            id: string;
            name: string;
            created: string;
            access_token: string;
            webhook_url: string | null;
          };
        }>
      >
    >(`/d/accounts/`, {
      params,
    })
    .catch((error) => {
      return Promise.reject(parseErrorsToArray(error)?.[0]);
    });
};

export const getFlowsWithSearch = async (
  searchKeyword?: string,
  accountId?: string
) => {
  const params: any = {
    offset: 0,
    limit: 10,
  };
  if (searchKeyword) {
    params.search = searchKeyword;
  }
  if (accountId) {
    params.accounts = accountId;
  }
  return axiosApiInstance
    .get<QueryResponse<Array<{ id: string; name: string }>>>(`/d/flows/`, {
      params,
    })
    .catch((error) => {
      return Promise.reject(parseErrorsToArray(error)?.[0]);
    });
};

export const getUsersWithSearch = async (searchKeyword?: string) => {
  const params: any = {
    offset: 0,
    limit: 10,
  };
  if (searchKeyword) {
    params.search = searchKeyword;
  }
  return axiosApiInstance
    .get<
      QueryResponse<
        Array<{
          columns: {
            id: number;
            name: string;
            email: string;
            role_name: string;
            date_joined: string;
          };
          preview: {
            id: number;
            name: string;
            email: string;
            role_name: string;
            date_joined: string;
          };
        }>
      >
    >(`/d/users/`, {
      params,
    })
    .catch((error) => {
      return Promise.reject(parseErrorsToArray(error)?.[0]);
    });
};
